/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import { TableContainer, Table, Thead, Tr, Tbody, Avatar, Text } from '@chakra-ui/react'
import { OutlineTable, StyledSpan } from './styles'
import { useEffect, useState } from 'react'
import { iNomeId, iParticipanteFeedbackResponse } from '../../../../interfaces'
import { FaTrash } from 'react-icons/fa'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { SelectCmp } from '../../../../components/SelectCmp'

interface iProps {
  colaboradores: iNomeId[]
  participantes: iParticipanteFeedbackResponse[]
  onExcluir: (participanteId: string) => void
  onUpdateGrupo: (grupoId: string, newGrupoId: string, participanteId: string) => void
}

interface iParticipanteTabela {
  responsavel?: iNomeId
  participante: iNomeId
	grupoId?: string
	id: string
}

export const TabelaParticipante: React.FC<iProps> = ({ onExcluir, colaboradores, participantes, onUpdateGrupo }) => {
  const [ColabsParticipantes, setColabsParticipantes] = useState<iParticipanteTabela[]>([])

  useEffect(() => {
    const resp: iParticipanteTabela[] = []
    participantes.forEach(e => {
      e.colaboradoresId.forEach(cid => {
        const part = colaboradores.find(e => e.id === cid)
        if (!part) return

        let responsavel: iNomeId | undefined

				if (e.responsaveisDefinidos?.some(rD => rD.participanteId === cid)) {
					const rd = e.responsaveisDefinidos?.find(rD => rD.participanteId === cid)
          responsavel = colaboradores.find(c => c.id === rd?.responsavelId)
				} else if (e.tipoResponsavel === 1) {
          responsavel = colaboradores.find(c => c.id === e.responsavelId)
        } else if (e.tipoResponsavel === 0) {
          responsavel = colaboradores.find(c => c.id === part.gestorId)
        }

        resp.push({ participante: part, responsavel: responsavel, grupoId: e.grupoId, id: e.id })
      })
    })
    setColabsParticipantes(resp)
  }, [participantes, colaboradores])

  return (
		<>
			<OutlineTable>
				<TableContainer>
					<Table variant='simple'>
						<Thead>
							<Tr _hover={{ bg: 'var(--c1) !important', color: 'black' }}>
							<th>Participante</th>
								<th>Responsável</th>
								<th>Grupo</th>
							</Tr>
						</Thead>
						<Tbody>
							{ColabsParticipantes?.sort((a, b) => a.participante.nome.localeCompare(b.participante.nome)).map((e, i) => {
							  return (
									<Tr key={i}>
										<td>
											<StyledSpan style={{ justifyContent: 'start', padding: '.5rem 1rem' }}>
												<Avatar src={e.participante.avatar} width={'2rem'} h={'2rem'} />
												<Text color={'Gray1'} fontWeight={'600'} fontSize={'12px'}>
													{e.participante.nome}
												</Text>
											</StyledSpan>
										</td>
										<td>
											{e.responsavel && <StyledSpan style={{ justifyContent: 'start', padding: '.5rem 1rem' }}>
												<Avatar src={e.responsavel?.avatar} width={'2rem'} h={'2rem'} />
												<Text color={'Gray1'} fontWeight={'600'} fontSize={'12px'}>
													{e.responsavel?.nome}
												</Text>
											</StyledSpan>}
											{!e.responsavel && <StyledSpan style={{ justifyContent: 'start', padding: '.5rem 1rem' }}>
												<Text color={'Gray1'} fontWeight={'600'} fontSize={'12px'}>
													Responsável não foi encontrado
												</Text>
											</StyledSpan>}
										</td>

										<td style={{ cursor: 'pointer' }}>
											<StyledSpan>
												<SelectCmp minW={'10rem'} fontSize='.75rem' value={e.grupoId ?? ''} OnChange={(idGrupo) => onUpdateGrupo(e.id, participantes.find(e => e.grupoId === idGrupo && e.colaboradoresId.length === 0)?.id ?? '', e.participante.id)}>
													<option value={''}>Nenhum</option>
													{participantes.filter(p => p.nomeGrupo && p.colaboradoresId.length === 0).map(p => {
														return <option value={p.grupoId}>{p.nomeGrupo}</option>
													})}
												</SelectCmp>
											</StyledSpan>
										</td>
										<td style={{ cursor: 'pointer' }}>
											<StyledSpan onClick={() => onExcluir(e.participante.id)}>
												<ElementoTooltipCmp label='Excluir' bg={'var(--Red)'}>
													<FaTrash color='var(--Red)'/>
												</ElementoTooltipCmp>
											</StyledSpan>
										</td>
									</Tr>
							  )
							})}
						</Tbody>
					</Table>
				</TableContainer>
			</OutlineTable>
		</ >
  )
}
